module.exports = require("@swa-ui/itinerary/src/FlightStops/FlightStops.module.scss");